import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Heading } from 'ui';
import { richLink } from '~/utils/richTextTags';
const faqLink = richLink({
  hasUnderline: true,
  href: 'https://www.byway.travel/faqs',
  isExternal: true,
  target: '_blank',
  'data-ua-click': 'faq-button'
});
const emailLink = richLink({
  hasUnderline: true,
  isExternal: true,
  target: '_blank',
  href: 'mailto:hello@byway.travel',
  'data-ua-click': 'contact-button'
});
export default function JourneySecureBooking() {
  const $ = _c(11);
  const t = useTranslations("journey");
  let t0;
  if ($[0] !== t) {
    t0 = t("secure_booking_heading");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <Heading as="h2" variant="h5"><span className="block mb-2 md:mb-3">{t0}</span></Heading>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t.rich("secure_booking_body", {
      faqLink,
      emailLink
    });
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <p>{t2}</p>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <div className="px-3 py-4 w-full bg-primary-200 md:px-6 md:pb-6 md:rounded-lg">{t1}{t3}</div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}